import { CalendarDays, Clock, Sparkles, Share2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { weekLessons } from "@/data/clubs";

const buildShareText = (schoolName, days, schoolId) => {
  const lines = [`*שיעורי השבוע · ${schoolName}*`, "פעילות החוגים חוזרת! שיעורי ניסיון בתיאום מראש — עד 11/10", ""];
  days.forEach((d) => {
    lines.push(`*יום ${d.day}*`);
    d.items.forEach((item) => {
      let line = `• ${item.club}`;
      if (item.time) line += ` ${item.time}`;
      if (item.note) line += ` — ${item.note}`;
      lines.push(line);
    });
    lines.push("");
  });
  lines.push(`לכל הפרטים: ${window.location.origin}/${schoolId}`);
  return lines.join("\n");
};

export const WeekLessons = ({ schoolId, schoolName }) => {
  const days = weekLessons[schoolId];
  if (!days?.length) return null;

  const shareHref = `https://wa.me/?text=${encodeURIComponent(buildShareText(schoolName, days, schoolId))}`;

  return (
    <section id="week-lessons" className="px-5 md:px-10 py-16 md:py-24 bg-ink text-paper" data-testid="week-lessons">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex items-center gap-2 text-accent font-head font-semibold mb-3">
            <CalendarDays className="w-5 h-5" />
            פתיחת שנת החוגים
          </div>
          <h2 className="font-head font-black text-4xl md:text-6xl tracking-tighter leading-none">
            שיעורי השבוע · {schoolName}
          </h2>
          <p className="mt-4 text-paper/60 md:text-lg">
            שיעורי ניסיון בתיאום מראש — עד 11/10
          </p>
          <a
            href={shareHref}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 font-head font-semibold bg-[#25D366] text-white px-6 py-3 rounded-full hover:bg-[#1eb955] transition-colors"
            data-testid="share-week-whatsapp"
          >
            <Share2 className="w-4 h-4" />
            שליחת שיעורי השבוע בוואטסאפ
          </a>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {days.map((d, di) => (
            <Reveal key={d.day} delay={di * 0.08}>
              <div className="rounded-2xl bg-white/[0.06] border border-white/10 p-5 h-full" data-testid={`week-day-${di}`}>
                <div className="font-head font-bold text-xl text-accent mb-4">יום {d.day}</div>
                <div className="space-y-4">
                  {d.items.map((item, ii) => (
                    <div key={ii} className="border-r-2 border-accent/60 pr-3">
                      <div className="font-head font-bold text-base">{item.club}</div>
                      {item.time && (
                        <div className="flex items-center gap-1.5 text-sm text-paper/70 mt-0.5">
                          <Clock className="w-3.5 h-3.5 text-accent shrink-0" />
                          <span className="tabular-nums" dir="ltr">{item.time}</span>
                        </div>
                      )}
                      {item.note && (
                        <div className="flex items-start gap-1.5 text-sm text-paper/80 mt-1">
                          <Sparkles className="w-3.5 h-3.5 text-accent shrink-0 mt-0.5" />
                          <span>{item.note}</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
